export const SET_UNAUTHORIZED_STATUS = "SET_UNAUTHORIZED_STATUS";
export const SET_SESSION_FAILURE_STATUS = "SET_SESSION_FAILURE_STATUS";
export const SET_FAILURE_STATUS = "SET_FAILURE_STATUS";
export const SET_DATA_PRIVACY_MODE = "SET_DATA_PRIVACY_MODE";
export const RESET_APP_STATE = "RESET_APP_STATE";
export const RESET_STATE = "RESET_STATE";